if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onFocusOut() {
      // setTimeout(() => {
      //   if (!this.contains(document.activeElement)) this.close();
      // })
    }

    closeDefault() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }

  window.DetailsDisclosure = DetailsDisclosure;
  scriptController.scripts.push('details-disclosure.js');
  customElements.define('details-disclosure', DetailsDisclosure);
}
